var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChangePin = function SvgChangePin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.425 15h1.18l-.103-2.198 1.935 1.193.593-.99L4.975 12l2.055-1.005-.593-.99-1.935 1.193L4.605 9h-1.18l.103 2.198-1.935-1.193-.593.99L3.055 12 1 13.005l.593.99 1.935-1.193L3.425 15ZM11.41 15h1.18l-.103-2.198 1.935 1.193.593-.99L12.96 12l2.055-1.005-.593-.99-1.935 1.193L12.59 9h-1.18l.103 2.198-1.935-1.193-.593.99L11.04 12l-2.055 1.005.593.99 1.935-1.193L11.41 15ZM19.395 15h1.18l-.103-2.198 1.935 1.193.593-.99L20.945 12 23 10.995l-.593-.99-1.935 1.193L20.575 9h-1.18l.103 2.198-1.936-1.193-.592.99L19.025 12l-2.055 1.005.593.99 1.935-1.193L19.395 15Z",
    fill: "#666"
  })));
};
export default SvgChangePin;